import { Typography } from 'antd';
import { EllipsisConfig } from 'antd/lib/typography/Base';
import cx from 'classnames';
import React from 'react';
import { AlarmQueueDevice } from '../../../../model/GraphicModel';
import styles from '../alarmQueue.module.scss';

const { Paragraph } = Typography;

type Props = {
	deviceInfo: Partial<AlarmQueueDevice>;
};

const DeviceContent = ({ deviceInfo }: Props) => {
	const nameEllipsisConfig: EllipsisConfig = {
		rows: 1,
		tooltip: { title: deviceInfo.Name },
	};

	const addressEllipsisConfig: EllipsisConfig = {
		rows: 1,
		tooltip: { title: deviceInfo.Address },
	};

	return (
		<div className={styles.deviceName}>
			<Paragraph className={cx(styles.text, styles.name)} ellipsis={nameEllipsisConfig}>
				<b>({deviceInfo.Count})</b> {deviceInfo.Name}
			</Paragraph>
			<Paragraph className={cx(styles.text, styles.address)} ellipsis={addressEllipsisConfig}>
				{deviceInfo.Address}
			</Paragraph>
		</div>
	);
};

export { DeviceContent };
